<template>
  <div class="audio-playback-section text-center">
    <div class="audio-visualizer">
      <div :ref="`visualizer-${attachmentOwnerId}`" class="audio-visualizer-waveform"></div>
      <small class="audio-visualizer-duration">{{duration}}</small>
    </div>

    <div class="player-controls text-center" @click="mediaPlayPause">
      <svg :viewBox="playPauseIcon.viewbox" class="play-pause-icon">
        <use :xlink:href="`#${playPauseText}-icon`"></use>
      </svg>
      <span>{{playPauseIcon.text}}</span>
    </div>
  </div>
</template>

<script>
  import LoadingIcon from '../shared/LoadingIcon'
  import WaveSurfer from 'wavesurfer.js'

  export default {
    props: {
      attachedMedia: Object,
      attachmentOwnerId: [Number, String],
      isAudioOpen: Boolean,
      mediaPlayerOptions: Object,
    },

    name: 'MediaPlayback',

    components: {
      LoadingIcon,
    },

    data() {
      return {
        duration: null,
        errorMessage: null,
        mediaUrl: null,
        playPauseText: 'play',
        waveSurferPlayer: null,
      }
    },

    methods: {
      buildPlayerOptions($player) {
        let playerOptions = {
          barRadius: 3,
          barWidth: 8,
          container: $player,
          cursorColor: '#016fb9',
          cursorWidth: 1,
          fillParent: true,
          height: 75,
          hideScrollbar: true,
          progressColor: '#128ff9',
          responsive: true,
          waveColor: 'rgba(18,143,249,.5)',
        }
        if (this.mediaPlayerOptions) {
          for (let key in this.mediaPlayerOptions) { playerOptions[key] = this.mediaPlayerOptions[key] }
        }
        return playerOptions
      },

      initWaveSurferPlayer() {
        const $player = this.$refs[`visualizer-${this.attachmentOwnerId}`]
        if (!this.waveSurferPlayer && $player) {
          const playerOptions = this.buildPlayerOptions($player)
          this.waveSurferPlayer = WaveSurfer.create(playerOptions)
          this.waveSurferPlayer.on('error', (error) => this.errorMessage = error)
          this.waveSurferPlayer.on('ready', () => this.setDuration() )
          this.waveSurferPlayer.on('finish', () => this.resetWhenFinishedPlaying() )
        }
      },

      loadWaveSurferPlayer() {
        if (this.attachedMedia && this.waveSurferPlayer) {
          this.mediaUrl = this.attachedMedia.url
          this.waveSurferPlayer.load(this.mediaUrl)
          this.$emit('setLoading', false)
        }
      },

      setDuration() {
        const duration = this.waveSurferPlayer.getDuration()
        let minutes = Math.floor(duration / 60)
        let seconds = Math.round(duration % 60)
        seconds = seconds < 10 ? `0${seconds}` : seconds
        this.duration = minutes >= 1 ? `${minutes}:${seconds}` : `:${seconds}`
      },

      mediaPlayPause() {
        if (this.waveSurferPlayer) {
          this.waveSurferPlayer.playPause()
          this.playPauseText = this.waveSurferPlayer.isPlaying() ? 'pause' : 'play'
        }
      },

      resetWhenFinishedPlaying() {
        this.waveSurferPlayer.seekTo(0)
        this.playPauseText = 'play'
      },
    },

    mounted() {
      this.initWaveSurferPlayer()
      this.loadWaveSurferPlayer()
    },

    beforeDestroy() {
      this.waveSurferPlayer && this.waveSurferPlayer.stop()
    },

    computed: {
      playPauseIcon: function () {
        const text = this.playPauseText === 'play' ? 'listen' : 'pause'
        const viewbox = this.playPauseText === 'play' ? '0 0 163.861 163.861' : '0 0 512 512'
        return {
          text,
          viewbox,
        }
      },
    },

    watch: {
      attachedMedia: function () {
        this.loadWaveSurferPlayer()
      },

      isAudioOpen: function () {
        if (!this.isAudioOpen && this.waveSurferPlayer && this.waveSurferPlayer.isPlaying()) {
          this.waveSurferPlayer.pause()
          this.playPauseText = 'play'
        }
      },
    }
  }
</script>